const API_HOST = "https://administravimas.diena.lt";
const API_ENDPOINT = `${API_HOST}/endpoint/popular/node`;
const BATCH_LIMIT = 4;
const AD_INSERT_INTERVAL = 4;
const PRELOAD_DISTANCE = 800;

Drupal.behaviors.mostReadArticlesBehaviour = {
  attach: function (context) {
    const contentLoader = once(
      "mostReadArticlesLoader",
      ".pager-wrapper .articles-loader",
      context
    );

    contentLoader.forEach((loader) => {
      const pagerWrapper = loader.closest(".pager-wrapper");
      const wrapper = pagerWrapper ? pagerWrapper.previousElementSibling : null;

      if (
        !wrapper ||
        !wrapper.classList.contains("most-read-articles-wrapper")
      ) {
        return;
      }

      const siteId = wrapper.dataset.siteId;

      if (!siteId) {
        return;
      }

      const state = {
        adIndex: 0,
        articlesSinceAd: 0,
        hasMore: true,
        isLoading: false,
        offset: 0,
        observer: null,
        siteId,
      };

      wrapper.setAttribute("aria-live", "polite");
      loader.setAttribute("aria-busy", "false");
      loader.dataset.state = "idle";

      state.observer = new IntersectionObserver(
        (entries) => {
          const isVisible = entries.some((entry) => entry.isIntersecting);

          if (isVisible) {
            loadNextBatch(wrapper, loader, state);
          }
        },
        {
          root: null,
          rootMargin: `0px 0px ${PRELOAD_DISTANCE}px 0px`,
          threshold: 0,
        }
      );

      state.observer.observe(loader);
      loadNextBatch(wrapper, loader, state);
    });
  },
};

const loadNextBatch = async (wrapper, loader, state) => {
  if (state.isLoading || !state.hasMore) {
    return;
  }

  let shouldLoadAhead = false;

  state.isLoading = true;
  loader.setAttribute("aria-busy", "true");
  loader.dataset.state = "loading";

  if (state.observer) {
    state.observer.unobserve(loader);
  }

  try {
    const articles = await fetchMostReadArticles(state.offset, state.siteId);
    const receivedCount = Array.isArray(articles) ? articles.length : 0;

    if (receivedCount === 0) {
      state.hasMore = false;
      loader.dataset.state = "done";
      return;
    }

    const articleMarkup = renderArticles(articles, state);

    if (articleMarkup.length !== 0) {
      wrapper.insertAdjacentHTML("beforeend", articleMarkup);
    }

    state.offset += receivedCount;
    state.hasMore = receivedCount === BATCH_LIMIT;
    loader.dataset.state = state.hasMore ? "idle" : "done";
    shouldLoadAhead = true;
  } catch (error) {
    console.log(`Failed to fetch most read articles. ${error}`);
    loader.dataset.state = "error";
  } finally {
    state.isLoading = false;
    loader.setAttribute("aria-busy", "false");

    if (state.hasMore && state.observer) {
      state.observer.observe(loader);

      if (shouldLoadAhead) {
        maybeLoadAhead(wrapper, loader, state);
      }
    }
  }
};

const fetchMostReadArticles = async (offset, siteId) => {
  const response = await fetch(
    `${API_ENDPOINT}?offset=${offset}&site=${siteId}&limit=${BATCH_LIMIT}`
  );

  if (!response.ok) {
    throw new Error(`Request failed with status ${response.status}`);
  }

  return response.json();
};

const maybeLoadAhead = (wrapper, loader, state) => {
  const loaderPosition = loader.getBoundingClientRect().top;

  // Keep loading while the sentinel is already in the preload zone.
  if (loaderPosition <= window.innerHeight + PRELOAD_DISTANCE) {
    window.requestAnimationFrame(() => {
      loadNextBatch(wrapper, loader, state);
    });
  }
};

const renderArticles = (articles, state) => {
  let articleContentPlaceholder = "";

  articles.forEach((element) => {
    if (!element || !element.values || Object.keys(element).length <= 2) {
      return;
    }

    articleContentPlaceholder += renderArticleCard(element);
    state.articlesSinceAd += 1;

    if (state.articlesSinceAd === AD_INSERT_INTERVAL) {
      articleContentPlaceholder += mobileAdByHost(state.adIndex);
      state.adIndex = getNextAdIndex(state.adIndex);
      state.articlesSinceAd = 0;
    }
  });

  return articleContentPlaceholder;
};

const renderArticleCard = (element) => {
  const values = element.values;
  const articleUrl = getArticleUrl(values);
  const commentsUrl = getCommentsUrl(articleUrl);
  const title = getFieldValue(values.title);
  const imageSrc = getImageUrl(element.image_url);
  const imageAlt = element.image_name || title;
  const fieldUpdated = getUpdatedLabel(values);
  const titlePostfix = getTitlePostfix(values);
  const primaryRubric = getPrimaryRubric(element);

  return `
      <div class="col-md-6 article-card">
        <article>
          <div class="media-block">
            <div class="media-wrapper">
              <div class="media-image">
                <img class="img-fluid" src="${imageSrc}" alt="${imageAlt}">
              </div>
              <a href="${articleUrl}" title="${title}"></a>
            </div>
          </div>
          <div class="article-card-info">
            <div class="article-media-info">
              ${getMediaIconsMarkup(values, commentsUrl)}
            </div>
            <div class="article-primary-rubric">
              ${primaryRubric}
            </div>
          </div>
          <a href="${articleUrl}" title="${title}">
            <h5>
              ${title}
              ${fieldUpdated}
            </h5>
            ${titlePostfix}
          </a>
      </article>
    </div>
    `;
};

const getImageUrl = (imagePath) => {
  if (!imagePath) {
    return "";
  }

  if (imagePath.startsWith("http://") || imagePath.startsWith("https://")) {
    return imagePath;
  }

  return `${API_HOST}${imagePath}`;
};

const getArticleUrl = (values) => {
  const alias = getNestedValue(values, ["path", 0, "alias"], "");
  const nid = getNestedValue(values, ["nid", 0, "value"], "");

  if (alias !== null && alias.length !== 0) {
    return alias;
  }

  return nid !== "" ? `/node/${nid}` : "";
};

const getCommentsUrl = (articleUrl) => {
  if (!articleUrl) {
    return "";
  }

  return `${articleUrl.replace(/\/$/, "")}/komentarai`;
};

const getFieldValue = (field, fallback = "") => {
  if (!Array.isArray(field) || field.length === 0 || field[0] === undefined) {
    return fallback;
  }

  return field[0].value !== undefined ? field[0].value : fallback;
};

const getNestedValue = (source, path, fallback = "") => {
  let value = source;

  for (const key of path) {
    if (value === null || value === undefined || value[key] === undefined) {
      return fallback;
    }

    value = value[key];
  }

  return value;
};

const getUpdatedLabel = (values) => {
  const updatedValue = getFieldValue(values.field_updated, 0);

  if (String(updatedValue) === "1") {
    return '<span class="text-danger pl-1">(Papildyta)</span>';
  }

  if (String(updatedValue) === "2") {
    return '<span class="text-danger pl-1">(Atnaujinta)</span>';
  }

  return "";
};

const getTitlePostfix = (values) => {
  const postfix = getFieldValue(values.field_papildoma_antrastes_inform, "");

  if (!postfix) {
    return "";
  }

  return `<span class="title-postfix">${postfix}</span>`;
};

const getPrimaryRubric = (element) => {
  const values = element.values;
  const rubrics = Array.isArray(values.field_rubric) ? values.field_rubric : [];

  if (rubrics.length !== 0) {
    if (rubrics[0].target_id == 25925) {
      return "Vilniaus miesto pulsas";
    }

    if (rubrics[0].target_id == 25947) {
      return "Kauno miesto pulsas";
    }

    if (rubrics[0].target_id == 25951) {
      return "Klaipėdos miesto pulsas";
    }
  }

  return Array.isArray(element.rubric) && element.rubric[0]
    ? element.rubric[0]
    : "";
};

const getMediaIconsMarkup = (values, commentsUrl) => {
  let iconsMarkup = "";
  const premiumValue = getFieldValue(values.field_premium_content, 0);
  const videoValue = getFieldValue(values.field_video, 0);
  const galleryField = Array.isArray(values.field_related_galleries)
    ? values.field_related_galleries
    : [];
  const commentsField = Array.isArray(values.field_komentarai)
    ? values.field_komentarai
    : [];
  const commentCount =
    commentsField[0] && commentsField[0].comment_count > 0
      ? commentsField[0].comment_count
      : 0;

  if (String(premiumValue) === "1") {
    iconsMarkup += '<span><i class="fa-solid fa-euro-sign"></i></span>';
  }

  if (galleryField[0]) {
    iconsMarkup += '<span><i class="fa-solid fa-camera"></i></span>';
  }

  if (String(videoValue) !== "0") {
    iconsMarkup += '<span><i class="fa-solid fa-circle-play"></i></span>';
  }

  if (commentCount > 0 && commentsUrl) {
    iconsMarkup += `<a href="${commentsUrl}" title="Visi komentarai">
                      <span class="publishing-info-icon">
                        <i class="fa-solid fa-comment"></i>
                        ${commentCount}
                      </span>
                    </a>`;
  }

  return iconsMarkup;
};

const getNextAdIndex = (index) => {
  if (index < 2) {
    return index + 1;
  }

  return 0;
};

const mobileAdByHost = (index) => {
  let hostname = window.location.hostname;
  if (hostname.startsWith("www.diena") || hostname.startsWith("diena")) {
    return '<div class="d-block w-100 text-align-center my-4"><script data-adfscript="adx.adform.net/adx/?mid=700284"></script></div>';
  } else if (hostname.startsWith("m.diena")) {
    if (index == 0) {
      return '<!-- Tag for diena.lt - VD M 300x600 placement --><div class="d-block w-100 text-align-center my-4"><script data-adfscript="adx.adform.net/adx/?mid=848483"></script></div>';
    } else if (index == 1) {
      return '<!-- Tag for diena.lt - VD M9 placement --><div class="d-block w-100 text-align-center my-4"><script data-adfscript="adx.adform.net/adx/?mid=847326"></script></div>';
    } else if (index == 2) {
      return '<!-- Tag for diena.lt - VD M10 placement --><div class="d-block w-100 text-align-center my-4"><script data-adfscript="adx.adform.net/adx/?mid=847327"></script></div>';
    }
  } else if (hostname.startsWith("klaipeda.diena")) {
    return '<div class="d-block w-100 text-align-center my-4"><script data-adfscript="adx.adform.net/adx/?mid=2005139"></script></div>';
  } else if (hostname.startsWith("m.klaipeda")) {
    if (index == 0) {
      return '<!-- Tag for klaipeda.diena.lt - KL M 300x600 placement --><div class="d-block w-100 text-align-center my-4"><script data-adfscript="adx.adform.net/adx/?mid=848482"></script></div>';
    } else if (index == 1) {
      return '<!-- Tag for klaipeda.diena.lt - KL M9 placement --><div class="d-block w-100 text-align-center my-4"><script data-adfscript="adx.adform.net/adx/?mid=847328"></script></div>';
    } else if (index == 2) {
      return '<!-- Tag for klaipeda.diena.lt - KL M10 placement --><div class="d-block w-100 text-align-center my-4"><script data-adfscript="adx.adform.net/adx/?mid=847329"></script></div>';
    }
  } else if (hostname.startsWith("kauno.diena")) {
    return '<div class="d-block w-100 text-align-center my-4"><script data-adfscript="adx.adform.net/adx/?mid=2027604"></script></div>';
  } else if (hostname.startsWith("m.kauno.diena")) {
    if (index == 0) {
      return '<!-- Tag for kauno.diena.lt - KD M 300x600 placement --><div class="d-block w-100 text-align-center my-4"><script data-adfscript="adx.adform.net/adx/?mid=833431"></script></div>';
    } else if (index == 1) {
      return '<!-- Tag for kauno.diena.lt - KD M9 placement --><div class="d-block w-100 text-align-center my-4"><script data-adfscript="adx.adform.net/adx/?mid=847324"></script></div>';
    } else if (index == 2) {
      return '<!-- Tag for kauno.diena.lt - KD M10 placement --><div class="d-block w-100 text-align-center my-4"><script data-adfscript="adx.adform.net/adx/?mid=847325"></script></div>';
    }
  } else {
    return "";
  }
};
